
<div class="brand-header">
  <ng-container *ngIf="data.logo">
    <img [src]="data.logo" class="brand-logo" alt="{{data.companyName}}">
  </ng-container>
  <div class="brand-details">
    <h1>{{ data.companyName | camelcase}}</h1>
    <ng-container *ngIf="data.url">
      <a class="data-url"
      (click)="sanitizeUrl(data.url); $event.preventDefault();"
      rel="noopener noreferrer"
      >
        {{ data.url }}
      </a>
        </ng-container>
        </div>
  
</div>
<!-- <div class="total-results">
  <strong>Total Results {{ products.length }} </strong>
</div> -->
  <div class="parent-container">
    <div class="filter"  *ngIf="type === 'brand'">
      <!-- <app-brand-product-filter [filterColumns]="['Products', 'Region', 'Application', 'Size', 'Shape', 'Model', 'SampleType']" [heading]="'Explore Products'" [isProducts]="true" [data]="originalData" (filteredData)="onFilteredData($event)"></app-brand-product-filter> -->
      <app-brand-product-filter [id]="data.id" [brandProfileProducts]="brandProfileProducts"  [type]="type" [filterColumns]="filterColumns" [data]="originalData" (filteredData)="onFilteredData($event)"  ></app-brand-product-filter>

    </div>
    <div class="product-list">
        <!-- <div class="no-records-found"> No records Found </div> -->
        <div *ngIf="products.length===0 && type === 'brand'" class="no-results">
          <img src="../../../../assets/images/Empty bin.png" alt="no-records-found" class="no-results-image">
          <div class="no-records-found"> No Products Found </div>
        </div>
        <div *ngIf="products.length===0 && type === 'distributor'"  class="no-results no-results-found">
          <img src="../../../../assets/images/Empty bin.png" alt="no-records-found" class="no-results-image">
          <div class="no-records-found"> No Records Found </div>
        </div>
      <ng-container *ngFor="let product of paginatedItems">
        <div  *ngIf="type === 'brand'" class="categories d-flex flex-column flex-wrap" style=" min-width: 260px;">
            <app-product-info-card class="product-cards"
                [id]="product.id"
                [productImage]="product.images[0]"
                [title]="product.name"
                [isCategoryCard]="false"
                [subtitleImage]="product.logo"
                [hoverText]="product.description"
                [contentItems]="product.specifications"
                [oemId]="product.oemId"
            >
            </app-product-info-card>
        </div>
    </ng-container>

    <ng-container *ngFor="let product of paginatedItems">
      <div  *ngIf="type === 'distributor'" class="categories d-flex flex-column flex-wrap" style=" min-width: 260px;">
          <app-product-info-card class="product-cards"
              [id]="product.id"
              [productImage]="product.image"
              [title]="product.name"
              [isCategoryCard]="true"
              [isDisplay]="true" 
              [disableHoverTransform]="true"
            >
            </app-product-info-card>
        </div>
    </ng-container>

    </div>
  </div>
  <div class="pagination-container">
    <app-pagination [itemsPerPage]="itemsPerPage" [data]="products" (pageChanged)="onPageChanged($event)"></app-pagination>
    <p class="end-text" style="color: #0D87C8;margin-left: 25px;">Total Entries: {{products.length}}</p>

  </div>
